import { TrendingUp, TrendingDown } from "lucide-react";

const ITEMS = [
  { label: "Brent Crude", price: "82.40", unit: "USD/bbl", delta: 0.8 },
  { label: "WTI Crude", price: "78.15", unit: "USD/bbl", delta: -0.4 },
  { label: "Bitumen 60/70 FOB SG", price: "430.00", unit: "USD/MT", delta: 1.2 },
  { label: "Base Oil SN150", price: "865.00", unit: "USD/MT", delta: 0.3 },
  { label: "Base Oil SN500", price: "890.00", unit: "USD/MT", delta: 0.5 },
  { label: "Paraxylene CFR Asia", price: "1012.00", unit: "USD/MT", delta: -0.6 },
  { label: "Methanol CFR SEA", price: "338.00", unit: "USD/MT", delta: 0.9 },
];

function TickerItem({ item }) {
  const up = item.delta >= 0;
  return (
    <span className="mx-6 inline-flex items-center gap-2 whitespace-nowrap">
      <span className="text-slate-400">{item.label}</span>
      <span className="font-mono text-white">{item.price}</span>
      <span className="font-mono text-slate-500">{item.unit}</span>
      <span className={`inline-flex items-center gap-1 font-mono ${up ? "text-brand" : "text-red-400"}`}>
        {up ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
        {up ? "+" : ""}{item.delta}%
      </span>
    </span>
  );
}

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="commodity-ticker"
      className="relative h-8 overflow-hidden border-b border-navy-600/60 bg-navy-800 text-xs"
      title="Indicative market prices"
    >
      <div className="ticker-track flex h-8 w-max items-center">
        {doubled.map((item, i) => (
          <TickerItem key={`${item.label}-${i}`} item={item} />
        ))}
      </div>
    </div>
  );
}
